import React from 'react';
import { AlertTriangle, Loader } from 'lucide-react';

/**
 * Reusable styled confirmation modal matching Revvoo design system.
 *
 * Props:
 * - isOpen: boolean
 * - onClose: () => void
 * - onConfirm: () => void
 * - title: string
 * - message: string | React node
 * - confirmText: string (default "Confirm")
 * - cancelText: string (default "Go Back")
 * - variant: 'danger' | 'primary' (default 'danger')
 * - loading: boolean
 * - icon: optional React node (default AlertTriangle for danger)
 */
function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmText = 'Confirm',
  cancelText = 'Go Back',
  variant = 'danger',
  loading = false,
  icon
}) {
  if (!isOpen) return null;

  const isDanger = variant === 'danger';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="confirm-modal" onClick={e => e.stopPropagation()}>
        <div className="confirm-modal-icon-wrap" style={{
          background: isDanger ? '#FEE2E2' : '#DBEAFE',
          color: isDanger ? '#DC2626' : '#2563EB'
        }}>
          {icon || <AlertTriangle size={28} />}
        </div>
        <h3 className="confirm-modal-title">{title}</h3>
        <div className="confirm-modal-message">{message}</div>
        <div className="confirm-modal-buttons">
          <button
            className="confirm-modal-cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button
            className={`confirm-modal-confirm-btn ${isDanger ? 'danger' : 'primary'}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader className="spinner" size={16} />
                Processing...
              </>
            ) : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
